import React from 'react'

const AppFooter = () => {
  return (
    <div className='appFooter'>AppFooter</div>
  )
}

export default AppFooter